import { render, staticRenderFns } from "./develop.vue?vue&type=template&id=fc9dd702&scoped=true"
import script from "./develop.vue?vue&type=script&lang=js"
export * from "./develop.vue?vue&type=script&lang=js"
import style0 from "./develop.vue?vue&type=style&index=0&id=fc9dd702&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc9dd702",
  null
  
)

export default component.exports